const cmi = ({ cmi }) => cmi
const completionStatus = ({ cmi }, entryId) =>
  cmi?.[entryId]?.data?.completionStatus

export default {
  cmi,
  completionStatus,
}
